import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemCommonModule } from '../system-common/system-common.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { ContestWiseComponent } from './insurerDashboard/contestWise/contestWise.component';
import { IncomeVsExpenseComponent } from './insurerDashboard/incomeVsExpense/incomeVsExpense.component';
import { DashboardService } from './services/dashboard.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { RegionWiseChartComponent } from './common-dashboards/region-channel-wise-chart/region-channel-wise-chart.component';
import { BarChartComponent } from './Dashboards/barchart/barchart.component';
import { DoughnutChartComponent } from './Dashboards/doughnutChart/doughnutChart.component';
import { AgentsPerformanceChartComponent } from './common-dashboards/performingAgents/performingAgents.component';
import { PartnerWiseChartComponent } from './common-dashboards/partnerWiseChart/partnerWiseChart.component';
import { DashboardLandingPageComponent } from './dashboard-landing-page/dashboard-landing-page.component';
import { ProductWiseChartComponent } from './common-dashboards/productWiseChart/productWiseChart.component';
import { LineChartComponent } from './Dashboards/line-chart/line-chart.component';
import { InsurerPremiumChartComponent } from './common-dashboards/insurer-premium-chart/insurer-premium-chart.component';
import { IncomevsExpenseCommonChartComponent } from './common-dashboards/income-vs-expense/income-vs-expense.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PerformanceLandingPageComponent } from './performance-landing-page/performance-landing-page.component';

@NgModule({
  declarations: [
    ContestWiseComponent,
    IncomeVsExpenseComponent,
    DashboardLandingPageComponent,
    PerformanceLandingPageComponent,
    RegionWiseChartComponent,
    BarChartComponent,
    LineChartComponent,
    DoughnutChartComponent,
    AgentsPerformanceChartComponent,
    ProductWiseChartComponent,
    PartnerWiseChartComponent,
    InsurerPremiumChartComponent,
    IncomevsExpenseCommonChartComponent,
  ],
  imports: [CommonModule, SystemCommonModule, DashboardRoutingModule, FormsModule, NgSelectModule, DragDropModule],
  exports: [
    ContestWiseComponent,
    IncomeVsExpenseComponent,
    RegionWiseChartComponent,
    DashboardLandingPageComponent,
    PerformanceLandingPageComponent,
    BarChartComponent,
    LineChartComponent,
    DoughnutChartComponent,
    AgentsPerformanceChartComponent,
    ProductWiseChartComponent,
    PartnerWiseChartComponent,
    InsurerPremiumChartComponent,
    IncomevsExpenseCommonChartComponent,
  ],
  providers: [DashboardService],
})
export class DashboardModule {}
